import { useEffect } from 'react';

const LoginSession = () => {
	useEffect(() => {
		function refreshTab(event) {
			console.log('event', event)
			if (event.key === 'user.accessToken' && event.newValue !== event.oldValue) {
				window.location.reload();
			}
		}
		if (typeof window !== 'undefined') {
			window.addEventListener('storage', refreshTab);
		}


		// Cleanup function to remove the event listener on unmount
		return () => {
			if (typeof window !== 'undefined') {
				window.removeEventListener('storage', refreshTab);
			}
		};
	}, []); // Empty dependency array ensures it runs once on mount and unmount

	return null;
}

export default LoginSession